import styles from './styles.module.css'
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { useState } from 'react'
import { authApi } from '../../services/api/api'
import useAuth from '../../hooks/useAuth'
import { toast } from "react-toastify"

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import TextEditor from '../textEditor';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { Pen, Trash2 } from 'lucide-react';

export default function Comment({ item, atualizar, setAtualizar }: any) {

    const api = authApi()

    const { user } = useAuth()

    const [likes, setLikes] = useState<number>(item.likes)

    const [liked, setLiked] = useState<boolean>(item.like ? true : false)

    const [text, setText] = useState<string>(item.description ?? '')


    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    async function handleLikeComment(comment_id: number) {


        if (user) {
            const response = await api.likeCommet(user.id, comment_id)

            if (response === 201) {
                setLikes((old) => old - 1)
                setLiked(false)
                return
            }
            setLikes((old) => old + 1)
            setLiked(true)
        }
    }

    async function handleDelete() {

        const response = await api.deleteComment(item.id)

        if (response == 200) {
            toast.success('Comentário excluído com sucesso.', { theme: 'dark', toastId: 'deleteComment' })
            setAtualizar(!atualizar)
            handleClose()
            return
        }
        toast.error('Não foi possível excluir o comentário.', { theme: 'dark', toastId: 'errorComment' })
        handleClose()
        return
    }

    async function handleUpdate() {

        const data = {
            'comment': item.id,
            'text': text
        }

        const response = await api.updateComment(data)

        if (response == 200) {
            toast.success('Comentário atualizado com sucesso.', { theme: 'dark', toastId: 'editComment' })
            setAtualizar(!atualizar)
            handleClose1()
            return
        }
        toast.error('Não foi possível editar o comentário.', { theme: 'dark', toastId: 'errorComment' })
        handleClose1()
        return
    }

    return (
        <div className="flex justify-between gap-4 mb-4 dark:text-white w-full " >
            <div className="flex gap-3 items-start mb-6 group animate-in fade-in slide-in-from-left-2 duration-300">

                {/* Avatar e Like Lateral */}
                <div className="flex flex-col items-center gap-2 shrink-0">
                    <img
                        src={item?.user.img}
                        alt={item?.user.name}
                        className="w-9 h-9 rounded-full object-cover border-2 border-white dark:border-blue-700 shadow-sm"
                    />
                    <button
                        onClick={() => handleLikeComment(item.id)}
                        className={`flex gap-1 items-center transition-all ${liked ? 'text-red-600' : 'text-gray-400 hover:text-red-500'}`}
                    >
                        {liked ? <Favorite sx={{ fontSize: 16 }} /> : <FavoriteBorder sx={{ fontSize: 16 }} />}
                        <span className="text-[10px] font-bold">{likes}</span>
                    </button>
                </div>

                {/* Bolha de Conteúdo */}
                <div className="flex-1 min-w-0">
                    <div className="bg-gray-100 dark:bg-slate-700/50 rounded-2xl rounded-tl-none p-3 shadow-sm border border-transparent dark:border-white/5">

                        {/* Header do Comentário: Nome e Ações */}
                        <div className="flex justify-between items-center mb-1">
                            <span className="text-xs font-bold text-blue-900 dark:text-blue-300">
                                {item?.user.name}
                            </span>

                            {item.user_id == user.id && (
                                <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <button onClick={handleClickOpen1} className="p-1 text-gray-400 hover:text-blue4 transition-colors">
                                        <Pen size={14} />
                                    </button>
                                    <button onClick={handleClickOpen} className="p-1 text-gray-400 hover:text-red-500 transition-colors">
                                        <Trash2 size={14} />
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Texto do Comentário */}
                        <div className="text-sm text-gray-700 dark:text-gray-200 leading-relaxed">
                            <div
                                className={`max-h-32 overflow-y-auto ${styles.scroll} pr-2`}
                                dangerouslySetInnerHTML={{ __html: item.description }}
                            ></div>
                        </div>
                    </div>

                    {/* Data ou tempo atrás (Opcional, mas dá um toque profissional) */}
                    <span className="ml-2 text-[9px] text-gray-400 uppercase font-bold tracking-widest opacity-80">
                        {item.created_at ? new Date(item.created_at).toLocaleDateString('pt-BR', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        }) : "Data indisponível"}
                    </span>
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Escreva seu comentário."}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h1>Tem certeza que deseja excluir o comentario?</h1>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Deletar
                    </Button>
                    <Button onClick={handleClose} autoFocus >
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Escreva seu comentário."}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* <textarea className='w-96 h-40' onChange={(e) => setText(e.target.value)} value={text}></textarea> */}
                        <TextEditor text={text} setText={setText} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpdate} autoFocus>
                        Atualizar
                    </Button>
                    <Button onClick={handleClose1} autoFocus >
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}